/* eslint-disable max-len */
import { debounce } from 'lodash';

/* eslint-disable no-param-reassign */
class CloudTagsGenerator {
  static defaultOptions = {
    tagSelector: '[data-entity="tag"]',
    iconSelector: '[data-entity="tag-icon"]',
    defaultSize: 16,
    minSize: 14,
    maxSize: 36,
    defaultIconSize: 32,
    iconSizeScale: 1.25,
    initOnDesktopOnly: false,
    hasIcons: false,
  };

  static renderTextTag(tag, fontSize) {
    tag.style.fontSize = `${fontSize}px`;
  }

  static renderTextTagWithIcon(tag, icon, fontSize, iconSize) {
    tag.style.fontSize = `${fontSize}px`;
    icon.style.width = `${iconSize}px`;
    icon.style.height = `${iconSize}px`;
  }

  constructor(rootElement, options = {}) {
    this.rootElement = rootElement;
    this.config = {
      desktopBreakpoint: 1280,
    };

    this.options = {
      ...CloudTagsGenerator.defaultOptions,
      ...options,
    };

    this.options.hightMinSize = this.options.maxSize - 6;
    this.options.mediumMinSize = this.options.hightMinSize - 4;

    this.findElements();
    this.initUiState();
    this.init();

    if (this.options.initOnDesktopOnly) {
      this.attachEvents();
    }
  }

  findElements() {
    this.tags = this.rootElement.querySelectorAll(this.options.tagSelector);
  }

  initUiState() {
    this.uiState = {
      textSize: this.options.minSize,
      iconSize: this.options.minSize * this.options.iconSizeScale,
    };
  }

  init() {
    this.tags.forEach((tag) => {
      if (this.options.initOnDesktopOnly
        && window.innerWidth < this.config.desktopBreakpoint) return;

      this.uiState.priority = tag.dataset.priority || 'random';
      this.uiState.textSize = this.getRandomTextSize(this.uiState.priority);
      this.uiState.iconSize = this.calcIconSize();

      if (this.options.hasIcons) {
        const icon = tag.querySelector(this.options.iconSelector);
        CloudTagsGenerator.renderTextTagWithIcon(
          tag,
          icon,
          this.uiState.textSize,
          this.uiState.iconSize,
        );
      } else {
        CloudTagsGenerator.renderTextTag(
          tag,
          this.uiState.textSize,
        );
      }
    });

    setTimeout(() => {
      this.renderRootElement();
    }, 300);
  }

  attachEvents() {
    const debouncedHandler = debounce(this.windowResizeHandler.bind(this), 400);
    window.addEventListener('resize', debouncedHandler);
  }

  windowResizeHandler() {
    if (window.innerWidth < this.config.desktopBreakpoint) return;

    this.init();
  }

  getRandomTextSize(priority) {
    switch (priority) {
      case 'random':
        return Math.ceil(
          Math.random() * (this.options.maxSize - this.options.minSize) + this.options.minSize,
        );
      case 'hight':
        return Math.ceil(
          Math.random() * (this.options.maxSize - this.options.hightMinSize) + this.options.hightMinSize,
        );
      case 'medium':
        return Math.ceil(
          Math.random() * ((this.options.hightMinSize - 1) - this.options.mediumMinSize) + this.options.mediumMinSize,
        );
      case 'low':
        return Math.ceil(
          Math.random() * ((this.options.mediumMinSize - 1) - this.options.minSize) + this.options.minSize,
        );
      default:
        return false;
    }
  }

  calcIconSize() {
    return Math.ceil(this.uiState.textSize * this.options.iconSizeScale);
  }

  renderRootElement() {
    this.rootElement.classList.add('generated');
  }
}

export default CloudTagsGenerator;
